import './underwriting.overview.underwriting-financial-analysis-summary.scss';

import {
  FormContainerWithHeader,
  FormTextField,
} from '../../../../presentation';

import { Box } from '@mui/material';
import { getFieldProps } from '@converge/data';
import { useTranslation } from 'react-i18next';

export const UnderwritingOverviewUnderwritingFinancialAnalysisSummary = () => {
  const { t } = useTranslation();

  return (
    <Box className="underwriting-financial-analysis-summary">
      <FormContainerWithHeader title={t('Financial Analysis Summary')}>
        <FormTextField
          {...getFieldProps('financialAnalysisSummary', false, '')}
          containerWidth={12}
          isRichText
        />
      </FormContainerWithHeader>
    </Box>
  );
};
